import { AutofillDetailKey, FIELD_TYPE } from "types/Models/Filing";

export const ADDRESS_DETAIL_KEY: AutofillDetailKey = "address_details";

export const AUTOFILL_KEY_TO_DETAIL_KEY: Record<string, AutofillDetailKey> = {
  addresses: ADDRESS_DETAIL_KEY,
  bank_details: "bank_details",
  persona_details: "persona_details",
};

/** Pickers that are answered once the section has a selected autofill */
export const AUTOFILL_PICKER_FIELD_TYPES = [
  "select_autofill",
  "select_principal_officer_autofill",
  "select_authorized_signatory_autofill",
  "select_bank_autofill",
];

export const DIRECTORS_PICKER_FIELD_TYPE = "select_directors_autofill";

export const EMAIL_FIELD_TYPE = "email";

export const REQUIRED_FIELD_ERROR = "This field is required";
export const INVALID_EMAIL_ERROR = "Invalid email address";
export const UPLOAD_OR_LINK_ERROR = "Please upload a document or add a link";
export const DELAWARE_AGENT_ADDRESS_ERROR =
  "You cannot use your Delaware Registered Agent address. Doing so may lead to rejection by the state authority.";

/** Address picker that must not hold a Delaware Registered Agent address */
export const PRINCIPAL_PLACE_OF_BUSINESS_FIELD_KEY =
  "principle_place_of_business";

/** Set on every director row once a director is picked */
export const DIRECTOR_AUTOFILL_DETAIL_KEY = "director_autofill_uuid";

/** Field types that hold their own value in the form values */
export const VALUE_FIELD_TYPES = [
  "text",
  FIELD_TYPE.TEXTAREA,
  "number",
  "amount",
  "phone",
  "email",
  "password",
  "select",
  "multiselect",
  "radio",
  FIELD_TYPE.CHECKBOX,
  "date",
  FIELD_TYPE.NON_US_ENTITY_SELECT,
  "filing_choice",
  "file_upload",
];
